import { PapiExtendedGroup } from '@wix/da-papi-types';

export const getCanCreateGroupGalleryFolder = (
  extendedGroup: PapiExtendedGroup | undefined
): boolean => !!extendedGroup?.apps?.gallery?.canCreateFolder;

export const getCanRearrangeGroupGalleryFolders = (
  extendedGroup: PapiExtendedGroup | undefined
): boolean => !!extendedGroup?.apps?.gallery?.canRearrangeFolders;

export const getCanSubmitToGroupGallery = (extendedGroup: PapiExtendedGroup | undefined): boolean =>
  !!extendedGroup?.apps?.gallery?.canSubmit;

export const getCanSubmitToGroupPosts = (extendedGroup: PapiExtendedGroup | undefined): boolean =>
  !!extendedGroup?.apps?.posts?.canSubmit;
